module.exports = __webpack_public_path__ + "static/media/mama.bad555b8.webp";